//#region assets/store-locator.ts
var LEAFLET_CSS = "https://cdn.jsdelivr.net/npm/leaflet@1.9.4/dist/leaflet.css";
var LEAFLET_JS = "https://cdn.jsdelivr.net/npm/leaflet@1.9.4/dist/leaflet.js";
var PDOK_URL = "https://api.pdok.nl/bzk/locatieserver/search/v3_1/free";
var DETAIL_ZOOM = 16;
var WEEKDAYS = [
	"sun",
	"mon",
	"tue",
	"wed",
	"thu",
	"fri",
	"sat"
];
var PIN_SVG = `
  <svg class="store-locator__pin-svg" width="44" height="58" viewBox="0 0 44 58" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M22 57C22 57 42 35.2 42 22C42 10.4 33.2 2 22 2S2 10.4 2 22C2 35.2 22 57 22 57Z" fill="#000000"/>
    <g transform="translate(8.4 11.2) scale(0.58)">
      <path d="M20.203 7.99652C21.5569 7.97595 22.9578 7.99776 24.3155 8.00109C23.9579 9.22503 23.45 10.5831 23.0226 11.7986L17.8813 26.6107C16.2455 26.6625 14.6085 26.6601 12.9729 26.6034C11.2434 21.5677 9.32831 16.6054 7.59214 11.5718C7.1859 10.3942 6.76504 9.17617 6.30273 8.02272C7.69525 7.96718 9.16507 7.99462 10.5648 8.00043C11.8178 11.1877 12.7792 14.6309 14.0027 17.8468C14.4668 19.0666 15.081 20.5772 15.3995 21.8147C17.3598 17.4819 18.5216 12.3656 20.203 7.99652Z" fill="white"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M25.9793 8.00241L31.4288 7.98993C33.0073 7.98765 34.5089 7.92449 36.0686 8.20893C38.4954 8.63453 40.0837 10.7837 40.2135 13.213C40.4822 18.2377 38.5259 19.7461 33.9325 20.2014C32.5115 20.2868 31.065 20.266 29.6397 20.2624L29.634 26.6318C28.4098 26.6617 27.185 26.6614 25.9608 26.6307C25.9233 20.541 25.8648 14.0741 25.9793 8.00241ZM29.6395 11.6364C31.3623 11.6515 33.4231 11.4331 35.0644 11.8441C36.6963 12.2526 36.5994 15.082 35.671 16.0957C34.4937 16.8984 31.1344 16.7705 29.6453 16.7527C29.6258 15.0601 29.6409 13.3318 29.6395 11.6364Z" fill="white"/>
    </g>
  </svg>
`;
var leafletLoader;
function loadLeaflet() {
	if (window.L) return Promise.resolve(window.L);
	if (leafletLoader) return leafletLoader;
	leafletLoader = new Promise((resolve, reject) => {
		if (!document.querySelector("link[data-leaflet-css]")) {
			const link = document.createElement("link");
			link.rel = "stylesheet";
			link.href = LEAFLET_CSS;
			link.dataset.leafletCss = "true";
			document.head.appendChild(link);
		}
		const existing = document.querySelector("script[data-leaflet-js]");
		if (existing) {
			existing.addEventListener("load", () => resolve(window.L), { once: true });
			existing.addEventListener("error", reject, { once: true });
			return;
		}
		const script = document.createElement("script");
		script.src = LEAFLET_JS;
		script.async = true;
		script.dataset.leafletJs = "true";
		script.onload = () => resolve(window.L);
		script.onerror = () => reject(/* @__PURE__ */ new Error("Leaflet failed to load"));
		document.head.appendChild(script);
	});
	return leafletLoader;
}
function parseHours(value) {
	if (!value) return null;
	try {
		return JSON.parse(value);
	} catch {
		return null;
	}
}
function toMinutes(time) {
	const [hours, minutes] = String(time).split(":").map((part) => Number(part));
	if (!Number.isFinite(hours) || !Number.isFinite(minutes)) return null;
	return hours * 60 + minutes;
}
function formatTime(time) {
	const [hours, minutes] = String(time).split(":");
	if (!hours) return time;
	return `${hours.padStart(2, "0")}:${(minutes || "00").padStart(2, "0")}`;
}
function amsterdamClock() {
	const parts = new Intl.DateTimeFormat("en-GB", {
		timeZone: "Europe/Amsterdam",
		weekday: "short",
		hour: "2-digit",
		minute: "2-digit",
		hourCycle: "h23"
	}).formatToParts(/* @__PURE__ */ new Date());
	const get = (type) => parts.find((part) => part.type === type)?.value || "";
	return {
		day: {
			Sun: 0,
			Mon: 1,
			Tue: 2,
			Wed: 3,
			Thu: 4,
			Fri: 5,
			Sat: 6
		}[get("weekday")] ?? (/* @__PURE__ */ new Date()).getDay(),
		minutes: Number(get("hour")) * 60 + Number(get("minute"))
	};
}
function hoursForDay(hours, dayIndex) {
	if (!hours) return null;
	const range = hours[WEEKDAYS[dayIndex]];
	if (!Array.isArray(range) || range.length < 2) return null;
	return range;
}
function nextOpenLabel(hours, dayIndex) {
	for (let offset = 1; offset <= 7; offset += 1) {
		const range = hoursForDay(hours, (dayIndex + offset) % 7);
		if (!range) continue;
		const open = formatTime(range[0]);
		if (offset === 1) return `Opent morgen om ${open}`;
		return `Opent om ${open}`;
	}
	return "";
}
function statusForHours(hours) {
	if (!hours) return null;
	const { day, minutes } = amsterdamClock();
	const today = hoursForDay(hours, day);
	if (today) {
		const open = toMinutes(today[0]);
		const close = toMinutes(today[1]);
		if (open != null && close != null && minutes >= open && minutes < close) return {
			open: true,
			state: "Open",
			detail: `Sluit om ${formatTime(today[1])}`
		};
		if (open != null && minutes < open) return {
			open: false,
			state: "Gesloten",
			detail: `Opent om ${formatTime(today[0])}`
		};
	}
	return {
		open: false,
		state: "Gesloten",
		detail: nextOpenLabel(hours, day) || ""
	};
}
function haversineKm(lat1, lng1, lat2, lng2) {
	const toRad = (value) => value * Math.PI / 180;
	const dLat = toRad(lat2 - lat1);
	const dLng = toRad(lng2 - lng1);
	const a = Math.sin(dLat / 2) ** 2 + Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) ** 2;
	return 12742 * Math.asin(Math.sqrt(a));
}
function parsePdokPoint(wkt) {
	const match = String(wkt).match(/POINT\(([-\d.]+)\s+([-\d.]+)\)/i);
	if (!match) return null;
	return {
		lng: Number(match[1]),
		lat: Number(match[2])
	};
}
async function geocodeQuery(query) {
	const url = `${PDOK_URL}?q=${encodeURIComponent(query)}&rows=1`;
	const response = await fetch(url);
	if (!response.ok) return null;
	const doc = (await response.json())?.response?.docs?.[0];
	if (!doc?.centroide_ll) return null;
	return parsePdokPoint(doc.centroide_ll);
}
var StoreLocator = class extends HTMLElement {
	connectedCallback() {
		if (this._booted) return;
		this._booted = true;
		this.panel = this.querySelector("[data-store-locator-panel]");
		this.list = this.querySelector("[data-store-locator-list]");
		this.countEl = this.querySelector("[data-store-locator-count]");
		this.searchInput = this.querySelector("[data-store-locator-search]");
		this.mapEl = this.querySelector("[data-store-locator-map]");
		this.countTemplate = this.dataset.countTemplate || "{count} vestigingen";
		this.items = Array.from(this.querySelectorAll("[data-store-locator-item]"));
		this.markersById = /* @__PURE__ */ new Map();
		this.activeId = null;
		this.searchTimer = null;
		this.items.forEach((item) => this.hydrateStatus(item));
		this.bindList();
		this.bindSearch();
		this.updateCount(this.items.length);
		this.initMap();
	}
	disconnectedCallback() {
		this.map?.remove();
		this.map = null;
		this._booted = false;
	}
	hydrateStatus(item) {
		const statusEl = item.querySelector("[data-store-locator-status]");
		const status = statusForHours(parseHours(item.dataset.hours));
		if (!statusEl || !status) return;
		statusEl.dataset.open = status.open ? "true" : "false";
		const detail = status.detail ? `<span class="store-locator__status-sep" aria-hidden="true">·</span>
         <span class="store-locator__status-hours type-paragraph-tiny">${status.detail}</span>` : "";
		statusEl.innerHTML = `
      <span class="store-locator__status-dot" aria-hidden="true"></span>
      <span class="store-locator__status-state">${status.state}</span>
      ${detail}
    `;
	}
	bindList() {
		this.items.forEach((item) => {
			const summary = item.querySelector("summary");
			if (!summary) return;
			summary.addEventListener("click", (event) => {
				event.preventDefault();
				if (item.open) this.closeItem(item, { resetMap: !this.isMobile() });
				else this.openItem(item, { fly: true });
			});
		});
	}
	bindSearch() {
		if (!this.searchInput) return;
		this.searchInput.addEventListener("input", () => {
			clearTimeout(this.searchTimer);
			this.searchTimer = setTimeout(() => this.applySearch(this.searchInput.value), 280);
		});
		this.searchInput.addEventListener("keydown", (event) => {
			if (event.key === "Enter") {
				event.preventDefault();
				clearTimeout(this.searchTimer);
				this.applySearch(this.searchInput.value);
			}
		});
	}
	async applySearch(rawQuery) {
		const query = rawQuery.trim().toLowerCase();
		if (!query) {
			this.items.forEach((item) => {
				item.hidden = false;
				item.style.order = "";
			});
			this.updateCount(this.items.length);
			this.closeAll();
			this.fitAll();
			return;
		}
		const textMatches = this.items.filter((item) => {
			return [
				item.dataset.name,
				item.dataset.address,
				item.dataset.city,
				item.dataset.postcode
			].join(" ").toLowerCase().includes(query);
		});
		let origin = null;
		try {
			origin = await geocodeQuery(rawQuery.trim());
		} catch {
			origin = null;
		}
		const visible = origin ? this.items : textMatches;
		const ranked = origin ? [...visible].sort((a, b) => this.distanceTo(a, origin) - this.distanceTo(b, origin)) : visible;
		this.items.forEach((item) => {
			item.hidden = !ranked.includes(item);
			item.style.order = "";
		});
		ranked.forEach((item, index) => {
			item.style.order = String(index);
		});
		this.updateCount(ranked.length);
		if (ranked.length === 1) {
			this.openItem(ranked[0], { fly: true });
			return;
		}
		this.closeAll();
		if (origin) this.fitAround(origin, ranked.slice(0, 4));
		else this.fitItems(ranked);
	}
	distanceTo(item, origin) {
		const lat = Number(item.dataset.lat);
		const lng = Number(item.dataset.lng);
		if (!Number.isFinite(lat) || !Number.isFinite(lng)) return Number.POSITIVE_INFINITY;
		return haversineKm(origin.lat, origin.lng, lat, lng);
	}
	updateCount(count) {
		if (!this.countEl) return;
		this.countEl.textContent = this.countTemplate.replace("{count}", String(count));
	}
	openItem(item, { fly = false, immediate = false } = {}) {
		this.items.forEach((other) => {
			if (other !== item && other.open) this.closeItem(other);
		});
		item.open = true;
		this.activeId = item.dataset.locationId;
		this.syncMarkerState();
		if (fly) this.flyToItem(item, { immediate });
	}
	closeItem(item, { resetMap = false } = {}) {
		item.open = false;
		if (this.activeId === item.dataset.locationId) this.activeId = null;
		this.syncMarkerState();
		if (resetMap) this.fitAll();
	}
	closeAll() {
		this.items.forEach((item) => {
			if (item.open) item.open = false;
		});
		this.activeId = null;
		this.syncMarkerState();
	}
	async initMap() {
		if (!this.mapEl) return;
		try {
			const L = await loadLeaflet();
			this.L = L;
			this.buildMap(L);
		} catch (error) {
			console.warn("[store-locator]", error);
		}
	}
	buildMap(L) {
		this.map = L.map(this.mapEl, {
			zoomControl: false,
			scrollWheelZoom: false,
			attributionControl: true
		});
		L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
			attribution: "&copy; <a href=\"https://www.openstreetmap.org/copyright\">OpenStreetMap</a>",
			maxZoom: 19
		}).addTo(this.map);
		L.control.zoom({ position: "bottomright" }).addTo(this.map);
		this.addLocateControl(L);
		this.markerLayer = L.layerGroup().addTo(this.map);
		this.items.forEach((item) => this.addMarker(L, item));
		requestAnimationFrame(() => {
			this.map.invalidateSize();
			if (this.isMobile() && this.items[0]) {
				this.openItem(this.items[0], {
					fly: true,
					immediate: true
				});
				return;
			}
			this.fitAll({ animate: false });
		});
		window.addEventListener("resize", () => {
			this.map?.invalidateSize();
		}, { passive: true });
	}
	addLocateControl(L) {
		const Control = L.Control.extend({ onAdd: () => {
			const wrap = L.DomUtil.create("div", "leaflet-bar store-locator__locate-wrap");
			const button = L.DomUtil.create("button", "store-locator__locate", wrap);
			button.type = "button";
			button.title = "Gebruik mijn locatie";
			button.setAttribute("aria-label", "Gebruik mijn locatie");
			button.innerHTML = `
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="1.6"/>
            <path d="M12 3v3M12 18v3M3 12h3M18 12h3" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
          </svg>
        `;
			L.DomEvent.disableClickPropagation(wrap);
			button.addEventListener("click", () => this.locateUser());
			return wrap;
		} });
		this.map.addControl(new Control({ position: "bottomright" }));
	}
	locateUser() {
		if (!navigator.geolocation) return;
		navigator.geolocation.getCurrentPosition((position) => {
			const origin = {
				lat: position.coords.latitude,
				lng: position.coords.longitude
			};
			const ranked = [...this.items].sort((a, b) => this.distanceTo(a, origin) - this.distanceTo(b, origin));
			ranked.forEach((item, index) => {
				item.hidden = false;
				item.style.order = String(index);
			});
			this.updateCount(ranked.length);
			this.fitAround(origin, ranked.slice(0, 3));
		}, () => {}, {
			enableHighAccuracy: true,
			timeout: 8e3
		});
	}
	pinIcon(L, active = false) {
		return L.divIcon({
			className: `store-locator__marker${active ? " is-active" : ""}`,
			html: PIN_SVG,
			iconSize: [44, 58],
			iconAnchor: [22, 56],
			popupAnchor: [0, -44]
		});
	}
	addMarker(L, item) {
		const lat = Number(item.dataset.lat);
		const lng = Number(item.dataset.lng);
		if (!Number.isFinite(lat) || !Number.isFinite(lng)) return;
		const marker = L.marker([lat, lng], {
			icon: this.pinIcon(L, false),
			title: item.dataset.name,
			riseOnHover: true
		});
		marker.on("click", () => this.openItem(item, { fly: true }));
		marker.addTo(this.markerLayer);
		this.markersById.set(item.dataset.locationId, marker);
	}
	syncMarkerState() {
		if (!this.L) return;
		this.markersById.forEach((marker, id) => {
			marker.setIcon(this.pinIcon(this.L, id === this.activeId));
			if (id === this.activeId) marker.setZIndexOffset(1e3);
			else marker.setZIndexOffset(0);
		});
	}
	isMobile() {
		return window.matchMedia("(max-width: 749px)").matches;
	}
	mapPadding() {
		if (!this.isMobile() && this.panel && this.mapEl) {
			const panelRect = this.panel.getBoundingClientRect();
			const mapRect = this.mapEl.getBoundingClientRect();
			const leftPadding = Math.max(48, panelRect.right - mapRect.left + 48);
			const bottomPadding = Math.max(80, mapRect.bottom - panelRect.bottom + 48);
			return {
				paddingTopLeft: [leftPadding, 48],
				paddingBottomRight: [48, bottomPadding]
			};
		}
		return { padding: [40, 40] };
	}
	flyToItem(item, { immediate = false } = {}) {
		if (!this.map || !this.L) return;
		const lat = Number(item.dataset.lat);
		const lng = Number(item.dataset.lng);
		if (!Number.isFinite(lat) || !Number.isFinite(lng)) return;
		if (immediate) {
			this.map.setView([lat, lng], DETAIL_ZOOM, { animate: false });
			return;
		}
		const bounds = this.L.latLngBounds([[lat, lng], [lat, lng]]);
		this.map.flyToBounds(bounds, {
			...this.mapPadding(),
			maxZoom: DETAIL_ZOOM,
			duration: .85
		});
	}
	visibleItems() {
		return this.items.filter((item) => !item.hidden);
	}
	fitAll({ animate = true } = {}) {
		this.fitItems(this.visibleItems(), { animate });
	}
	fitItems(items, { animate = true } = {}) {
		if (!this.map || !this.L) return;
		const points = items.map((item) => [Number(item.dataset.lat), Number(item.dataset.lng)]).filter(([lat, lng]) => Number.isFinite(lat) && Number.isFinite(lng));
		if (!points.length) return;
		const bounds = this.L.latLngBounds(points);
		this.map.fitBounds(bounds, {
			...this.mapPadding(),
			maxZoom: 10,
			animate
		});
	}
	fitAround(origin, items) {
		if (!this.map || !this.L) return;
		const points = [[origin.lat, origin.lng]];
		items.forEach((item) => {
			const lat = Number(item.dataset.lat);
			const lng = Number(item.dataset.lng);
			if (Number.isFinite(lat) && Number.isFinite(lng)) points.push([lat, lng]);
		});
		this.map.fitBounds(this.L.latLngBounds(points), {
			...this.mapPadding(),
			maxZoom: 12,
			animate: true
		});
	}
};
if (!customElements.get("vp-store-locator")) customElements.define("vp-store-locator", StoreLocator);
//#endregion
